/**
 * Somatus Hybrid Scheduler API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CalenderModel } from '../model/calenderModel';
import { CareMemberCalenderEvents } from '../model/careMemberCalenderEvents';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class HSCalendarService {

    protected basePath = 'http://localhost:5001/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param meetingId 
     * @param comment 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public hSCalendarCancelMeetingStatus(meetingId: string, comment: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public hSCalendarCancelMeetingStatus(meetingId: string, comment: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public hSCalendarCancelMeetingStatus(meetingId: string, comment: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public hSCalendarCancelMeetingStatus(meetingId: string, comment: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (meetingId === null || meetingId === undefined) {
            throw new Error('Required parameter meetingId was null or undefined when calling hSCalendarCancelMeetingStatus.');
        }

        if (comment === null || comment === undefined) {
            throw new Error('Required parameter comment was null or undefined when calling hSCalendarCancelMeetingStatus.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('put',`${this.basePath}/api/HSCalendar/cancel/${encodeURIComponent(String(meetingId))}/${encodeURIComponent(String(comment))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public hSCalendarCreate(body: CalenderModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public hSCalendarCreate(body: CalenderModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public hSCalendarCreate(body: CalenderModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public hSCalendarCreate(body: CalenderModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling hSCalendarCreate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/api/HSCalendar`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * @param careMemberId
     * @param startDateTime
     * @param endDateTime
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public hSCalendarMemberSchedule(careMemberId: number | number[], startDateTime?: Date, endDateTime?: Date, observe?: 'body', reportProgress?: boolean): Observable<CareMemberCalenderEvents[]>;
    public hSCalendarMemberSchedule(careMemberId: number | number[], startDateTime?: Date, endDateTime?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CareMemberCalenderEvents[]>>;
    public hSCalendarMemberSchedule(careMemberId: number | number[], startDateTime?: Date, endDateTime?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CareMemberCalenderEvents[]>>;
    public hSCalendarMemberSchedule(careMemberId: number | number[], startDateTime?: Date, endDateTime?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (careMemberId === null || careMemberId === undefined) {
            throw new Error('Required parameter careMemberId was null or undefined when calling hSCalendarMemberSchedule.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = ['application/json','text/json','application/_*+json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) 
    { headers = headers.set('Content-Type', httpContentTypeSelected);}
        const careMemberIds = Array.isArray(careMemberId) ? careMemberId : [careMemberId];
        
        return this.httpClient.request<CareMemberCalenderEvents[]>('post',`${this.basePath}/api/HSCalendar/schedules`,
            {
                body: {
                    careMemberIds: careMemberIds,
                    startDateTime: startDateTime,
                    endDateTime: endDateTime
                },
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param startDateTime 
     * @param endDateTime 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public hSCalendarMySchedule(startDateTime?: Date, endDateTime?: Date, observe?: 'body', reportProgress?: boolean): Observable<CareMemberCalenderEvents>;
    public hSCalendarMySchedule(startDateTime?: Date, endDateTime?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CareMemberCalenderEvents>>;
    public hSCalendarMySchedule(startDateTime?: Date, endDateTime?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CareMemberCalenderEvents>>;
    public hSCalendarMySchedule(startDateTime?: Date, endDateTime?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDateTime !== undefined && startDateTime !== null) {
            queryParameters = queryParameters.set('startDateTime', <any>startDateTime.toISOString());
        }
        if (endDateTime !== undefined && endDateTime !== null) {
            queryParameters = queryParameters.set('endDateTime', <any>endDateTime.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CareMemberCalenderEvents>('get',`${this.basePath}/api/HSCalendar/schedules/mine`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param meetingId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public hSCalendarStatusByMeetingId(meetingId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public hSCalendarStatusByMeetingId(meetingId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public hSCalendarStatusByMeetingId(meetingId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public hSCalendarStatusByMeetingId(meetingId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (meetingId === null || meetingId === undefined) {
            throw new Error('Required parameter meetingId was null or undefined when calling hSCalendarStatusByMeetingId.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('get',`${this.basePath}/api/HSCalendar/status/meetings/${encodeURIComponent(String(meetingId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param careMemberId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public hSCalendarUpdateByCareMemberCalenderEventsDelta(careMemberId: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public hSCalendarUpdateByCareMemberCalenderEventsDelta(careMemberId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public hSCalendarUpdateByCareMemberCalenderEventsDelta(careMemberId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public hSCalendarUpdateByCareMemberCalenderEventsDelta(careMemberId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (careMemberId === null || careMemberId === undefined) {
            throw new Error('Required parameter careMemberId was null or undefined when calling hSCalendarUpdateByCareMemberCalenderEventsDelta.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('get',`${this.basePath}/api/HSCalendar/caremember/${encodeURIComponent(String(careMemberId))}/calender/slot/delta`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param fromDateTime 
     * @param toDateTime 
     * @param timeZone 
     * @param eventId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public hSCalendarUpdateCalendar(fromDateTime: string, toDateTime: string, timeZone: string, eventId: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public hSCalendarUpdateCalendar(fromDateTime: string, toDateTime: string, timeZone: string, eventId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public hSCalendarUpdateCalendar(fromDateTime: string, toDateTime: string, timeZone: string, eventId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public hSCalendarUpdateCalendar(fromDateTime: string, toDateTime: string, timeZone: string, eventId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (fromDateTime === null || fromDateTime === undefined) {
            throw new Error('Required parameter fromDateTime was null or undefined when calling hSCalendarUpdateCalendar.');
        }

        if (toDateTime === null || toDateTime === undefined) {
            throw new Error('Required parameter toDateTime was null or undefined when calling hSCalendarUpdateCalendar.');
        }

        if (timeZone === null || timeZone === undefined) {
            throw new Error('Required parameter timeZone was null or undefined when calling hSCalendarUpdateCalendar.');
        }

        if (eventId === null || eventId === undefined) {
            throw new Error('Required parameter eventId was null or undefined when calling hSCalendarUpdateCalendar.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/HSCalendar/update/${encodeURIComponent(String(fromDateTime))}/${encodeURIComponent(String(toDateTime))}/${encodeURIComponent(String(timeZone))}/${encodeURIComponent(String(eventId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param meetingId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public hSCalendarUpdateMeetingStatus(meetingId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public hSCalendarUpdateMeetingStatus(meetingId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public hSCalendarUpdateMeetingStatus(meetingId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public hSCalendarUpdateMeetingStatus(meetingId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (meetingId === null || meetingId === undefined) {
            throw new Error('Required parameter meetingId was null or undefined when calling hSCalendarUpdateMeetingStatus.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('put',`${this.basePath}/api/HSCalendar/schedules/${encodeURIComponent(String(meetingId))}/status`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
